'user strict'
const ex = require('../lib/error')
const Sequelize  = require('../config/db')
const customers = require('../models').customers
const sequelize = require('sequelize')
const Op = sequelize.Op

const createOrUpdateCustomer = (req, res, next) => {

	/*
	cases =>
	* (is_active = false) is the case when user tries to cancel a bill => no effect to customer
	* else if (customer has mobile no)
		search customer table by mobileNo & userid, findOrCreate, then update other fields (name, address)
	* else if (customer has no mobile no)
		search customer table by name & userid, findOrCreate, then update other fields (address)
	*/
	if (req.body.hasOwnProperty("is_active") && !(req.body.is_active)) {
		next();
	} else {

		let where = {};
		let defaults = {};

		if (req.body.customerMobileNo.length >= 10) {
			where = {
				mobileNo: req.body.customerMobileNo,
				userid: req.body.userid
			};
			defaults = {
				address: req.body.customerAddress,
				name: req.body.customerName
			}
		} else {
			where = {
				name: req.body.customerName,
				address: req.body.customerAddress,
				userid: req.body.userid,
				mobileNo: req.body.customerMobileNo
			};
			defaults = {
			}
		}
		customers.findOrCreate({
			where,
			defaults,
		})
			.then(([row, created]) => {
				req.body.customerid = row.dataValues.id;
				req.responseObject['customer'] = row.dataValues;
				if (!created && req.body.customerMobileNo.length >= 10) {
					customers.update(defaults, {
						where
					}).then(customer => {
						req.responseObject['customer'] = {
							...where,
							...defaults
						}
						delete req.body.customerName;
						delete req.body.customerMobileNo;
						delete req.body.customerAddress;
						next();
					}).catch(error => {
						ex.raiseError(req, res, 'OVA008', 500, error)
					})
				} else {
					next();
				}
			})
			.catch(error => {
				let errCode
				if (error.name === 'SequelizeUniqueConstraintError') {
					errCode = 'MAUD003'
				} else {
					errCode = 'MAUD004'
				}
				ex.raiseError(req, res, errCode, 500, error)
			})
	}
}


const findCustomer = (req, res, next) => {

	let customerName = req.body.customerName;
	customerName = customerName.toLowerCase(customerName);
	let limit = 5;
	let where = {
		userid: req.body.userid,
		$and: sequelize.where(
			Sequelize.fn('lower', Sequelize.col('name')),
			{
				[Op.like]: `${customerName}%`
			}
		)
	}

	customers.findAll({
		attributes: ['name', 'mobileNo', 'updatedAt'],
		order: [['updatedAt', 'DESC']],
		where: where, limit: limit
	})
		.then((customer) => {
			req.responseObject.data.customer = customer;
			next();
		})
		.catch(error => {
			console.log(error);
			let errCode
			if (error.name === 'SequelizeUniqueConstraintError') {
				errCode = 'MAUD003'
			} else {
				errCode = 'MAUD004'
			}
			ex.raiseError(req, res, errCode, 400, error)
		})
}

module.exports = {
	createOrUpdateCustomer,
	findCustomer
}
